import { userCan } from "@/lib/utils";
import notification from "element-ui/packages/notification";

const Home = () => import("@/pages/home/index");
const Organisation = () => import("@/pages/organisation/index");
const Transactions = () => import("@/pages/transactions/index");
const Developers = () => import("@/pages/developers/index");
const Settings = () => import("@/pages/settings/index");

let checkRoutePermissions = (to, from, next, group, action) => {
  const allowRouteView = userCan(group, action);

  if (allowRouteView) {
    next();
  } else {
    if (!from.name) {
      next({ name: "home.index" });
    }
    notification({
      title: "Access Denied",
      message:
        "You are not authorised to view this page. Contact Organisation Admin",
      customClass: "error"
    });
  }
};

const routes = () => {
  return [
    {
      path: "/home",
      name: "home.index",
      component: Home,
      meta: {
        requiresAuth: true,
        layout: "app",
        label: "Home"
      }
    },
    {
      path: "/organisation",
      name: "organisation.index",
      component: Organisation,
      meta: {
        requiresAuth: true,
        layout: "app",
        label: "Organisation"
      },
      beforeEnter: (to, from, next) => {
        checkRoutePermissions(to, from, next, "auth", "organisation.getone");
      }
    },
    {
      path: "/transactions",
      name: "transactions.index",
      component: Transactions,
      meta: {
        requiresAuth: true,
        layout: "app",
        label: "Transactions"
      },
      beforeEnter: (to, from, next) => {
        checkRoutePermissions(
          to,
          from,
          next,
          "payment",
          "wallet.getallhistory"
        );
      }
    },
    {
      path: "/developers",
      name: "developers.index",
      component: Developers,
      meta: {
        requiresAuth: true,
        layout: "app",
        label: "Developers"
      },
      beforeEnter: (to, from, next) => {
        checkRoutePermissions(to, from, next, "auth", "apiclient.getall");
      }
    },
    {
      path: "/settings",
      name: "settings.index",
      component: Settings,
      meta: {
        requiresAuth: true,
        layout: "app",
        label: "Settings"
      }
    }
  ];
};

export default routes();
